module.exports = __webpack_public_path__ + "img/nav_img_01.29711de7.jpg";